import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import "./Styles/login.css";
import Barcode from "react-barcode";
import SearchIcon from "@mui/icons-material/Search";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PictureInPictureAltIcon from "@mui/icons-material/PictureInPictureAlt";
import ClearIcon from "@mui/icons-material/Clear";
import config from "../config";

// Standalone Popup Component for Picture-in-Picture
function PiPContent() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [qrCodeData, setQrCodeData] = useState(null);
  const [guestVoucherInfo, setGuestVoucherInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateQrCodeString = (guestInfo, vouchers) => {
    if (!guestInfo || !vouchers || vouchers.length === 0) return "";
    const latestVoucher = vouchers.reduce((latest, current) => {
      return current.id > latest.id ? current : latest;
    });
    return latestVoucher.voucherCode;
  };

  const searchVouchersByPhone = async () => {
    if (!phoneNumber.trim()) {
      alert("Vui lòng nhập số điện thoại");
      return;
    }
    let validPhoneNumber = phoneNumber.trim();
    if (validPhoneNumber.startsWith('0')) {
      validPhoneNumber = validPhoneNumber.replace('0', '84');
    }

    setLoading(true);
    const token = localStorage.getItem('token');
    
    try {
      const response = await axios.get(
        `${config.apiEndpoint}/Voucher/by-phone/${validPhoneNumber}`,
        { 
          headers: token ? { Authorization: `Bearer ${token}` } : {}, 
          withCredentials: true 
        }
      );

      if (response.status === 200) {
        setGuestVoucherInfo(response.data);
        const qrString = generateQrCodeString(response.data.guestInfo, response.data.vouchers);
        setQrCodeData(qrString);
      }
    } catch (err) {
      console.error("Error fetching vouchers by phone:", err);
      alert("Không tìm thấy thông tin voucher cho số điện thoại này");
      setGuestVoucherInfo(null);
      setQrCodeData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setPhoneNumber("");
    setQrCodeData(null);
    setGuestVoucherInfo(null);
  };

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#f5f5f5",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
    }}>
      {/* Header */}
      <div style={{
        background: "linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%)",
        padding: "10px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px"
      }}>
        <span style={{ fontSize: "18px" }}>📊</span>
        <span style={{ color: "#fff", fontWeight: "600", fontSize: "14px" }}>
          Barcode - Always on Top
        </span>
      </div>

      {/* Search */}
      <div style={{ 
        padding: "12px", 
        backgroundColor: "#fff",
        borderBottom: "1px solid #eee"
      }}>
        <div style={{ display: "flex", gap: "6px" }}>
          <input
            type="text"
            placeholder="Số điện thoại..."
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && searchVouchersByPhone()}
            style={{
              flex: 1,
              padding: "10px 12px",
              fontSize: "13px",
              border: "2px solid #e1e5e9",
              borderRadius: "6px",
              outline: "none"
            }}
          />
          <button
            onClick={searchVouchersByPhone}
            disabled={loading}
            style={{
              padding: "10px 14px",
              backgroundColor: loading ? "#ccc" : "#9c27b0",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              cursor: loading ? "not-allowed" : "pointer",
              fontSize: "13px",
              fontWeight: "500"
            }}
          >
            {loading ? "..." : "🔍"}
          </button>
          {(qrCodeData || phoneNumber) && (
            <button
              onClick={handleClear}
              style={{
                padding: "10px 12px",
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer"
              }}
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* Result */}
      <div style={{ 
        flex: 1, 
        overflow: "auto", 
        padding: "12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}>
        {loading && (
          <div style={{ 
            display: "flex", 
            alignItems: "center", 
            justifyContent: "center",
            height: "100%"
          }}>
            <div style={{
              width: "30px",
              height: "30px",
              border: "3px solid #f3f3f3",
              borderTop: "3px solid #9c27b0",
              borderRadius: "50%",
              animation: "spin 1s linear infinite"
            }} />
            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
          </div>
        )}

        {!loading && guestVoucherInfo && (
          <div style={{ width: "100%", marginBottom: "12px" }}>
            <div style={{
              backgroundColor: "#fff",
              padding: "10px 12px",
              borderRadius: "8px",
              fontSize: "12px",
              border: "1px solid #e9ecef"
            }}>
              <p style={{ margin: "3px 0" }}><strong>👤</strong> {guestVoucherInfo.guestInfo.name}</p>
              <p style={{ margin: "3px 0" }}><strong>📞</strong> {guestVoucherInfo.guestInfo.phoneNumber}</p>
              <p style={{ margin: "3px 0" }}><strong>⭐</strong> {guestVoucherInfo.guestInfo.point?.toLocaleString('vi-VN')} điểm</p>
            </div>
          </div>
        )}

        {!loading && qrCodeData && (
          <div style={{
            width: "100%",
            padding: "15px",
            backgroundColor: "#fff",
            borderRadius: "10px",
            border: "2px solid #28a745",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}>
            <div style={{ marginBottom: "10px", color: "#28a745", fontWeight: "600", fontSize: "13px" }}>
              📊 Mã Barcode
            </div>
            <Barcode 
              value={qrCodeData}
              width={1.5}
              height={55}
              fontSize={9}
              margin={5}
              background="#ffffff"
              lineColor="#000000"
              displayValue={false}
            />
            <p style={{
              fontSize: "9px",
              color: "#666",
              marginTop: "10px",
              textAlign: "center",
              wordBreak: "break-all",
              padding: "6px 8px",
              backgroundColor: "#f8f9fa",
              borderRadius: "4px",
              fontFamily: "monospace",
              maxWidth: "100%"
            }}>
              {qrCodeData}
            </p>
          </div>
        )}

        {!loading && !qrCodeData && (
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#999",
            textAlign: "center"
          }}>
            <span style={{ fontSize: "40px", opacity: 0.3, marginBottom: "10px" }}>📊</span>
            <p style={{ fontSize: "12px", margin: 0 }}>Nhập SĐT để tra cứu</p>
          </div>
        )}
      </div>
    </div>
  );
}

function QrLookupPage() {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [qrCodeData, setQrCodeData] = useState(null);
  const [guestVoucherInfo, setGuestVoucherInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pipWindow, setPipWindow] = useState(null);
  const pipContainerRef = useRef(null);

  // Function to open Picture-in-Picture window (Always on Top)
  const openPictureInPicture = async () => {
    // Check if Document Picture-in-Picture API is supported
    if ('documentPictureInPicture' in window) {
      try {
        // Close existing PiP window if any
        if (pipWindow) {
          pipWindow.close();
        }

        const pip = await window.documentPictureInPicture.requestWindow({
          width: 380,
          height: 480,
        });

        setPipWindow(pip);

        // Copy styles to PiP window
        const styles = document.querySelectorAll('style, link[rel="stylesheet"]');
        styles.forEach(style => {
          pip.document.head.appendChild(style.cloneNode(true));
        });

        // Add base styles
        const baseStyle = pip.document.createElement('style');
        baseStyle.textContent = `
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { margin: 0; padding: 0; overflow: hidden; }
          @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
        `;
        pip.document.head.appendChild(baseStyle);

        // Create container and render React component
        const container = pip.document.createElement('div');
        container.style.cssText = 'width: 100%; height: 100vh;';
        pip.document.body.appendChild(container);

        // Render the PiP content
        ReactDOM.render(<PiPContent />, container);

        // Handle PiP window close
        pip.addEventListener('pagehide', () => {
          setPipWindow(null);
          ReactDOM.unmountComponentAtNode(container);
        });

      } catch (error) {
        console.error('Picture-in-Picture error:', error);
        // Fallback to regular popup
        openPopupWindow();
      }
    } else {
      // Fallback for browsers that don't support Document PiP
      alert('Trình duyệt không hỗ trợ Picture-in-Picture.\n\nSử dụng Chrome 116+ hoặc Edge 116+ để có tính năng Always on Top.\n\nĐang mở cửa sổ popup thông thường...');
      openPopupWindow();
    }
  };

  // Fallback: Regular popup window
  const openPopupWindow = () => {
    const width = 400;
    const height = 500;
    const left = window.screen.width - width - 50;
    const top = 50;
    
    const popupFeatures = [
      `width=${width}`,
      `height=${height}`,
      `left=${left}`,
      `top=${top}`,
      'resizable=yes',
      'scrollbars=no',
      'toolbar=no',
      'menubar=no',
      'location=no',
      'status=no'
    ].join(',');
    
    window.open('/qr-popup', 'QrLookupPopup', popupFeatures);
  };

  // Function to generate QR code data string
  const generateQrCodeString = (guestInfo, vouchers) => {
    if (!guestInfo || !vouchers || vouchers.length === 0) return "";
    const latestVoucher = vouchers.reduce((latest, current) => {
      return current.id > latest.id ? current : latest;
    });
    return latestVoucher.voucherCode;
  };

  // Function to search vouchers by phone number
  const searchVouchersByPhone = async () => {
    if (!phoneNumber.trim()) {
      alert("Vui lòng nhập số điện thoại");
      return;
    }
    let validPhoneNumber = phoneNumber.trim();
    if (validPhoneNumber.startsWith('0')) {
      validPhoneNumber = validPhoneNumber.replace('0', '84');
    }

    setLoading(true);
    const token = localStorage.getItem('token');
    
    try {
      const response = await axios.get(
        `${config.apiEndpoint}/Voucher/by-phone/${validPhoneNumber}`,
        { 
          headers: token ? { Authorization: `Bearer ${token}` } : {}, 
          withCredentials: true 
        }
      );

      if (response.status === 200) {
        setGuestVoucherInfo(response.data);
        const qrString = generateQrCodeString(response.data.guestInfo, response.data.vouchers);
        setQrCodeData(qrString);
      }
    } catch (err) {
      console.error("Error fetching vouchers by phone:", err);
      alert("Không tìm thấy thông tin voucher cho số điện thoại này");
      setGuestVoucherInfo(null);
      setQrCodeData(null);
    } finally {
      setLoading(false);
    }
  };

  const clearSearch = () => {
    setPhoneNumber("");
    setQrCodeData(null);
    setGuestVoucherInfo(null);
  };

  return (
    <div className="bodyWrap">
      <div className="contentLoginWrap">
        <div style={{
          width: "100%",
          maxWidth: "500px",
          margin: "0 auto",
          padding: "30px 20px",
          backgroundColor: "#fff",
          borderRadius: "15px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)"
        }}>
          {/* Header */}
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "25px",
            paddingBottom: "15px",
            borderBottom: "2px solid #007bff"
          }}>
            <QrCodeIcon style={{ fontSize: "28px", marginRight: "10px", color: "#007bff" }} />
            <h1 style={{ margin: 0, color: "#007bff", fontSize: "22px" }}>
              Tra cứu Barcode
            </h1>
          </div>

          {/* Open Popup Button */}
          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <button
              onClick={openPictureInPicture}
              style={{
                padding: "14px 28px",
                backgroundColor: "#9c27b0",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "600",
                display: "inline-flex",
                alignItems: "center",
                gap: "10px",
                transition: "all 0.2s",
                boxShadow: "0 4px 15px rgba(156,39,176,0.4)"
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#7b1fa2"}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#9c27b0"}
            >
              <PictureInPictureAltIcon style={{ fontSize: "20px" }} />
              🔝 Mở Popup Always on Top
            </button>
            <p style={{ fontSize: "11px", color: "#9c27b0", marginTop: "8px", fontWeight: "500" }}>
              ⭐ Cửa sổ luôn hiển thị trên cùng (Chrome/Edge 116+)
            </p>
          </div>

          <div style={{ 
            borderTop: "1px solid #eee", 
            paddingTop: "20px",
            marginTop: "10px"
          }}>
            <p style={{ 
              fontSize: "13px", 
              color: "#666", 
              textAlign: "center",
              marginBottom: "15px"
            }}>
              Hoặc tìm kiếm ngay tại đây:
            </p>

            {/* Search Section */}
            <div style={{ display: "flex", gap: "8px", marginBottom: "20px" }}>
              <input
                type="text"
                placeholder="Nhập số điện thoại..."
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    searchVouchersByPhone();
                  }
                }}
                style={{
                  flex: 1,
                  padding: "12px 14px",
                  fontSize: "14px",
                  border: "2px solid #e1e5e9",
                  borderRadius: "8px",
                  outline: "none",
                  transition: "border-color 0.2s"
                }}
                onFocus={(e) => e.target.style.borderColor = "#007bff"}
                onBlur={(e) => e.target.style.borderColor = "#e1e5e9"}
              />
              <button
                onClick={searchVouchersByPhone}
                disabled={loading}
                style={{
                  padding: "12px 18px",
                  backgroundColor: loading ? "#ccc" : "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  cursor: loading ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px"
                }}
              >
                <SearchIcon style={{ fontSize: "18px" }} />
                {loading ? "..." : "Search"}
              </button>
              {(qrCodeData || phoneNumber) && (
                <button
                  onClick={clearSearch}
                  style={{
                    padding: "12px",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer"
                  }}
                >
                  <ClearIcon style={{ fontSize: "18px" }} />
                </button>
              )}
            </div>

            {/* Loading */}
            {loading && (
              <div style={{ textAlign: "center", padding: "30px" }}>
                <div style={{
                  width: "35px",
                  height: "35px",
                  border: "3px solid #f3f3f3",
                  borderTop: "3px solid #007bff",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto"
                }} />
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
              </div>
            )}

            {/* Guest Info */}
            {!loading && guestVoucherInfo && (
              <div style={{
                backgroundColor: "#f8f9fa",
                padding: "14px",
                borderRadius: "10px",
                fontSize: "13px",
                marginBottom: "15px"
              }}>
                <p style={{ margin: "5px 0" }}>
                  <strong>👤</strong> {guestVoucherInfo.guestInfo.name}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>📞</strong> {guestVoucherInfo.guestInfo.phoneNumber}
                </p>
                <p style={{ margin: "5px 0" }}>
                  <strong>⭐</strong> {guestVoucherInfo.guestInfo.point?.toLocaleString('vi-VN')} điểm
                </p>
              </div>
            )}

            {/* Barcode Display */}
            {!loading && qrCodeData && (
              <div style={{
                padding: "20px",
                backgroundColor: "#fff",
                borderRadius: "12px",
                border: "2px solid #28a745",
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }}>
                <h4 style={{
                  margin: "0 0 15px 0",
                  color: "#28a745",
                  fontSize: "15px"
                }}>
                  📊 Mã Barcode
                </h4>
                <Barcode 
                  value={qrCodeData}
                  width={1.8}
                  height={70}
                  fontSize={11}
                  margin={8}
                  background="#ffffff"
                  lineColor="#000000"
                  displayValue={false}
                />
                <p style={{
                  fontSize: "10px",
                  color: "#666",
                  marginTop: "12px",
                  textAlign: "center",
                  wordBreak: "break-all",
                  padding: "8px 12px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "6px",
                  fontFamily: "monospace"
                }}>
                  {qrCodeData}
                </p>
              </div>
            )}

            {/* Empty State */}
            {!loading && !qrCodeData && (
              <div style={{
                textAlign: "center",
                padding: "30px",
                color: "#999"
              }}>
                <QrCodeIcon style={{ fontSize: "50px", opacity: 0.2, marginBottom: "10px" }} />
                <p style={{ fontSize: "13px", margin: 0 }}>
                  Nhập số điện thoại để tra cứu
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default QrLookupPage;
